import { render, staticRenderFns } from "./consignordermanagement.vue?vue&type=template&id=327e02de&scoped=true&"
import script from "./consignordermanagement.vue?vue&type=script&lang=js&"
export * from "./consignordermanagement.vue?vue&type=script&lang=js&"
import style0 from "./consignordermanagement.vue?vue&type=style&index=0&id=327e02de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e02de",
  null
  
)

export default component.exports